import * as React from 'react'
import cx from 'classnames'

export interface LabelProps {
  children: React.ReactNode
  /** HTML for name attribute */
  name?: string
  disabled?: boolean
  className?: string
}

export const Label = ({ children, name, disabled, className }: LabelProps) => {
  return (
    <label
      className={cx(
        'mb-1 inline-block type-default font-semibold',
        disabled ? 'text-disabled' : 'text-default',
        className
      )}
      {...(name && { htmlFor: name })}
    >
      {children}
    </label>
  )
}
